import {
  PaginationProps,
  SortDirection,
} from "@touche-lts/panel-ui/dist/utilities";
import {
  ApiKeysTableSearchProps,
  ApiKeysTableSortProps,
} from "./api-keys-table-store.types";

export const initialApiKeysTablePaginationProps: PaginationProps<ApiKeysTableSortProps> =
  {
    page: 0,
    size: window.innerWidth >= 1920 ? 10 : 6,
    sortDirection: SortDirection.ASC,
    sortProp: ApiKeysTableSortProps.STORE_NAME,
    totalElements: 0,
    totalPages: 0,
  };

export const initialApiKeysTableSearchProps: ApiKeysTableSearchProps = {
  storeName: "",
};

export const apiKeysTableNeedTimeoutSearchProps: Array<
  keyof ApiKeysTableSearchProps
> = ["storeName"];
